import swaggerClient from "../remote-client";

export default class LoginServiceImpl {
  login() {
    return new Promise((resolve, reject) => {
      swaggerClient.userSwaggerClient
        .then(client => {
          return client.apis.UserReservedArea.getMemberInfo(
            {},
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(
          result => resolve(result),
          reason => reject(reason)
        );
    });
  }
}
